import React, { useState, useEffect } from 'react';
import { useMetamask } from "../Scripts/UseMetamask";
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLinksS,
  NavLogo,
  NavMenu,
  NavBtn,
  NavBtnConnect,
  NavBtnConnected,
  NavMusic
} from './NavbarElements';

const Navbar = ({ toggle }) => {
  const {connect, account} = useMetamask();
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav>
          <NavbarContainer>
            <NavLogo scrollNav={scrollNav}>
              bitGoblins.FTM
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
            <NavItem>
                <NavLinksS
                  scrollNav={scrollNav}
                  to='mint'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Mint
                </NavLinksS>
              </NavItem>
            <NavItem>
                <NavLinks
                  scrollNav={scrollNav}
                  target= '_blank'
                  href= 'https://twitter.com/BITGOBLINS/'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Twitter
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  scrollNav={scrollNav}
                  target= '_blank'
                  href= 'https://nftkey.app/collections/bitgoblinsftm/'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  NFTkey
                </NavLinks>
              </NavItem>
            </NavMenu>
            <NavBtn>
              {account ? (
                <NavBtnConnected>Connected</NavBtnConnected>
                ):(
                <NavBtnConnect scrollNav={scrollNav} onClick={ connect }>Connect</NavBtnConnect>
              )}
            </NavBtn>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
